import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const BlogContainer = styled(Box)`
  margin: 48px auto;
  padding: 0px 24px;
  max-width: 1136px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 32px;
  flex-direction: column-reverse;

  ${({ theme }) => theme.breakpoints.up('sm')} {
    flex-direction: row;
  }
  ${({ theme }) => theme.breakpoints.up('lg')} {
    padding: 0px;
    margin-top: 80px;
    margin-bottom: 100px;
    gap: 94px;
  }
`;

export const ButtonContainer = styled(Box)`
  width: 100%;
  display: flex;
  height: 40px;
  padding: 10px 20px;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  border-radius: 4px;
  border: 1px solid #00532a;
  font-size: 18px;
  font-weight: 500;
  line-height: 22px;
  color: #00532a;
  ${({ theme }) => theme.breakpoints.up('sm')} {
    width: 140px;
  }
`;
